import { ShieldAlert } from "lucide-react";
import { MODERATION_MESSAGE } from "@/lib/moderation";

/**
 * ModerationWarning — 1:1 web port of iOS
 * `mobile/src/components/ModerationWarning.tsx` (spec 11).
 *
 * Red Bronto-themed banner shown when the backend flags a post, reply
 * or different-view submission.  The thin Bronto rainbow strip on top
 * ties the warning into the brand while the body stays unmistakably
 * red.  Layout: rainbow strip (3px) + row(icon badge, title + copy).
 *
 * Colours pulled from CSS variables so light/dark modes both look right:
 *   border: theme.danger (--danger)
 *   fill:   theme.danger + "1A" (~10% alpha)
 */
export function ModerationWarning({ testId = "moderation-warning" }) {
  return (
    <div
      data-testid={testId}
      className="rounded-2xl overflow-hidden border-[1.5px]"
      style={{
        borderColor: "hsl(var(--danger))",
        backgroundColor: "hsl(var(--danger) / 0.1)",
      }}
    >
      <div
        className="h-[3px] w-full"
        style={{
          background:
            "linear-gradient(90deg, #FFD600, #FF7A00, #FF0069, #D300C5, #7638FA)",
        }}
      />
      <div className="flex items-start gap-2.5 px-3.5 py-3">
        <div
          className="w-7 h-7 rounded-full flex items-center justify-center shrink-0 mt-[1px]"
          style={{ backgroundColor: "hsl(var(--danger))" }}
        >
          <ShieldAlert size={16} color="#fff" strokeWidth={2.2} />
        </div>
        <div className="flex-1 min-w-0">
          <p
            className="font-extrabold tracking-[0.2px]"
            style={{
              color: "hsl(var(--danger))",
              fontSize: 13.5,
            }}
          >
            Content flagged
          </p>
          <p
            className="font-semibold mt-[3px]"
            style={{
              color: "hsl(var(--danger))",
              fontSize: 13.5,
              lineHeight: "19px",
            }}
          >
            {MODERATION_MESSAGE}
          </p>
        </div>
      </div>
    </div>
  );
}

export default ModerationWarning;
